module.exports = __webpack_public_path__ + "images/power-active.ddd78448f3679c26febe825cc76642e4.png";